module.exports = __webpack_public_path__ + "img/zggkw.7e8a12ab.png";